import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cursos/empresas/")({
  beforeLoad: () => {
    throw redirect({ to: "/cursos/empresas/programas-a-medida" });
  },
});
